import { translate } from '@/domains/core/localization/translate';
export const {
  frequentlyBoughtEngineNameTitle,
  frequentlyBoughtV3EngineNameTitle,
  similarityBottomBoostTitle,
  similarityModelBottomTitle,
  similarityModelTopTitle,
  similarityTopBoostTitle,
  similarityV2AlternateBottomTitle,
  similarityV2AlternateTopTitle,
  similarityV2TopTitle,
  frequentlyBoughtTogetherTitle,
  frequentlyBoughtTogetherAlternateTitle
} = translate({
  "similarityModelTopTitle": "You may also like",
  "similarityModelBottomTitle": "Customers also browsed",
  "similarityV2TopTitle": "You may also like",
  "similarityV2AlternateTopTitle": "You may also like",
  "similarityV2AlternateBottomTitle": "Customers also browsed",
  "similarityTopBoostTitle": "You may also like",
  "similarityBottomBoostTitle": "Customers also browsed",
  "frequentlyBoughtEngineNameTitle": "Often purchased together",
  "frequentlyBoughtV3EngineNameTitle": "Often purchased together",
  "frequentlyBoughtTogetherTitle": "Often purchased together",
  "frequentlyBoughtTogetherAlternateTitle": "Often purchased together"
});